import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { searchByVehicleDropDownPostDataInterface, searchByVehiclePostDataInterface } from 'src/_lib/interfaces/request-interfaces/vehicle-search.interface';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment.prod';
import { CommunicationService } from './communication.service';
import { BrowserService } from 'src/_lib/service/browser.service';

@Injectable({
  providedIn: 'root'
})

export class SearchByVehicleService {
  private endpoint: string = environment.apiUrl;
  private makeresponseData: any;
  private modelresponseData: any;
  private yearresponseData: any;
  private submodels1responseData: any;
  private submodels2responseData: any;
  private submodels3responseData: any;

  constructor(
    private http: HttpClient,
    private comm: CommunicationService,
    private router: Router,
    private browser: BrowserService
  ) { }

  getSearchByVehicleResults(data: searchByVehiclePostDataInterface): Observable<any> {
    return this.http.post<any>(this.endpoint + 'search-by-vehicle-results', data);
  }

  getDropDownDataSearchByVechicles(data: searchByVehicleDropDownPostDataInterface): Observable<any> {
    return this.http.post(this.endpoint + 'dap-search-by-vehicle', data);
  }

  clearVehicleSearch() {
    this.comm.clearVehicleData();
    this.browser.localStorage?.removeItem('vehiclesearchData');
    this.browser.localStorage?.removeItem('mmysubCategoriesDropDownData');
  }

  isSearchVehicleExists(): boolean {
    let vehicleName = this.browser.localStorage?.getItem('vehiclename') || null;
    return !vehicleName ? false : true;
  }

  setMakeResponseData(data: any): void {
    this.browser.localStorage?.setItem('makeData', JSON.stringify(data));
    this.makeresponseData = data;
  }

  setModelResponseData(data: any): void {
    this.browser.localStorage?.setItem('modelData', JSON.stringify(data));
    this.modelresponseData = data;
  }

  setYearResponseData(data: any): void {
    this.browser.localStorage?.setItem('yearData', JSON.stringify(data));
    this.yearresponseData = data;
  }

  setSubmodels1ResponseData(data: any): void {
    this.browser.localStorage?.setItem('submodels1', JSON.stringify(data));
    this.submodels1responseData = data;
  }

  setSubmodels2ResponseData(data: any): void {
    this.browser.localStorage?.setItem('submodels2', JSON.stringify(data));
    this.submodels2responseData = data;
  }

  setSubmodels3ResponseData(data: any): void {
    this.browser.localStorage?.setItem('submodels3', JSON.stringify(data));
    this.submodels3responseData = data;
  }

  getMakeResponseData(): any {
    return this.makeresponseData != null ? this.makeresponseData : JSON.parse(this.browser.localStorage?.getItem("makeData"));
  }

  getModelResponseData(): any {
    return this.modelresponseData != null ? this.modelresponseData : JSON.parse(this.browser.localStorage?.getItem("modelData"));
  }

  getYearResponseData(): any {
    return this.yearresponseData != null ? this.yearresponseData : JSON.parse(this.browser.localStorage?.getItem("yearData"));
  }

  getSubmodels1ResponseData(): any {
    return this.submodels1responseData != null ? this.submodels1responseData : JSON.parse(this.browser.localStorage?.getItem("submodels1"));
  }

  getSubmodels2ResponseData(): any {
    return this.submodels2responseData != null ? this.submodels2responseData : JSON.parse(this.browser.localStorage?.getItem("submodels2"));
  }

  getSubmodels3ResponseData(): any {
    return this.submodels3responseData != null ? this.submodels3responseData : JSON.parse(this.browser.localStorage?.getItem("submodels3"));
  }

  getVehicleForm(): any {
    return JSON.parse(this.browser.localStorage?.getItem('vehiclesearchForm') || 'null');
  }

  getVehicleName(): string {
    return this.browser.localStorage?.getItem('vehiclename') || '';
  }
}